import { createContext } from 'react'

export interface MaxContextData {
  pageCode: string,
  instanceId: string
}

export const MaxContext = createContext<MaxContextData | null>(null)
